import { SwRegistrationOptions } from '@angular/service-worker';

declare const PWA_ENABLED: boolean;

export function pwaRegistrationOptions(): SwRegistrationOptions {
  return {
    enabled: typeof PWA_ENABLED === 'boolean' && PWA_ENABLED,
    registrationStrategy: 'registerWhenStable:30000',
  };
}
